import { useState } from 'react';

const PRODUCT_MENU = [
  {
    id: '1',
    label: '개인보호구',
    items: [
      '귀마개 · 보안면',
      '우의 · 위생복 · 작업복',
      '장화 · 등산화 · 안전화',
      '방한용품 · 차광용품',
      '방진 * 방독 마스크',
      '비계화 · 정전화 · 절연화',
      '산소캔 · 공기호흡기',
      '신호수조끼 · 안전조끼',
      '안전그네 · 안전벨트',
      '제전복 · 화학복 · 방열복',
      '안전모 악세사리 · 안전모',
      '각종 보호대 · 측정기 · 구급함',
    ],
  },
  {
    id: '2',
    label: '도로안전용품',
    items: [
      '도로표지병 · 과속방지턱',
      '실내 * 실외 반사경',
      '점자블럭',
      '볼라드 · 차단봉',
      '코너보호대 · 주차용품',
      '방호벽 · 차선규제봉',
    ],
  },
  {
    id: '3',
    label: '공사안전용품',
    items: [
      '안전시설제 · 철골난간대 · 사다리 전도방지대',
      '타포린 · 시선유도파이프',
      '추락방지 망',
      '신호봉 · 바루사 · 델리네이트',
      '각종 거치대',
      '안전로프 · 위험테이프',
      '윙카 · 경광등 · 경고등',
      '안전펜스 · PE드럼 · 칼라콘',
    ],
  },
  {
    id: '4',
    label: '표지판/게시판',
    items: [
      '현수막 · 휘장막',
      '안전표지판 · 계몽표지판',
      '무재해 기록판',
      '점멸표시판 · 교명주',
    ],
  },
  {
    id: '5',
    label: '작업복',
    items: [
      '경비복·기타작업복',
      '가을·겨울 작업복',
      'ㄴ 작업복점퍼·파카',
      'ㄴ 한벌작업복·스즈키복',
      '조끼·티셔츠·아웃도어',
      '봄·여름 작업복',
      'ㄴ 작업복점퍼',
      'ㄴ 한벌작업복',
      '아이스조끼·쿨링점퍼',
    ],
  },
  {
    id: '6',
    label: '소방용품',
    items: [
      '소방도구보관함 · 위험물저장소',
      '완강기 · 화재대피용품',
      '각종 소화기',
      '방화복 · 방수복',
    ],
  },
  {
    id: '7',
    label: '기타안전용품',
    items: [
      '기타 안전용품',
      '이동식 편의시설',
      '환경용품',
      '플레쉬 · 랜턴',
      '둥근톱 커버',
    ],
  },
] as const;

const PRODUCT_IMAGE_MAP: Record<string, string[]> = {
  '1': ['1-1.png', '1-2.png', '1-3.png'],
  '2': ['2-1.png', '2-2.png', '2-3.png'],
  '3': ['3-1.png', '3-2.png', '3-3.png'],
  '4': ['4-1.png','4-2.png','4-3.png','4-4.png'],
  '5': ['5-1.png', '5-2.png', '5-3.jpg'],
  '6': ['6-1.png', '6-2.png','6-3.png','6-4.png'],
  '7': ['7-1.png', '7-2.png', '7-3.png','7-4.png'],
};

function ProductsPage() {
  const [selectedId, setSelectedId] = useState<string | null>('1');

  const handleCategoryClick = (id: string) => {
    setSelectedId(id);
  };

  const selectedCategory = PRODUCT_MENU.find((cat) => cat.id === selectedId);
  const imageNames = selectedId ? PRODUCT_IMAGE_MAP[selectedId] ?? [] : [];

  return (
    <section className="page">
      <h1 className="page-title">제품소개</h1>

      <div className="products-layout">
        <nav className="products-nav" aria-label="제품 카테고리">
        <ul className="products-nav__root">
          {PRODUCT_MENU.map((cat) => {
            const isOn = selectedId === cat.id;
            return (
              <li
                key={cat.id}
                className={`products-nav__item${isOn ? ' on' : ''}`}
              >
                <button
                  type="button"
                  className="products-nav__trigger"
                  aria-expanded={isOn}
                  onClick={() => handleCategoryClick(cat.id)}
                >
                  {cat.label}
                  <span className="products-nav__chevron" aria-hidden />
                </button>
                <ul className="products-nav__sub">
                  {cat.items.map((item) => {
                    const isSubLine = item.startsWith('ㄴ');
                    return (
                      <li key={`${cat.id}-${item}`}>
                        <span
                          className={
                            isSubLine
                              ? 'products-nav__sub-text products-nav__sub-text--sub'
                              : 'products-nav__sub-text'
                          }
                        >
                          {item}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
        </nav>
        <div className="products-panel" aria-label="제품 상세 영역">
          <div className="products-panel__images">
            {imageNames.map((fileName, index) => (
              <img
                key={fileName}
                src={`${process.env.PUBLIC_URL}/img/${fileName}`}
                alt={`${selectedCategory?.label ?? '제품'} 이미지 ${index + 1}`}
                className="products-panel__image"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductsPage;
